import React from 'react'

export const LoaderPage = () => {
  return (
    <div className="d-flex justify-content-center">
    <div className="spinner-border" role="status" style={{padding:"50px"}}>
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
  )
}


export const LoaderPagination = () => {
    return (
      <div className="d-flex justify-content-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
    )
  }

export const PageLoader = ({ message = "Loading..." }) => {
  return (
    <div className="w-full min-h-[60vh] flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-3">
        <svg
          className="w-10 h-10 animate-spin text-blue-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 000 16v4l3.5-3.5L12 20v4a8 8 0 01-8-8z"
          ></path>
        </svg>
        <p className="text-sm text-gray-500">{message}</p>
      </div>
    </div>
  );
};
